export enum ElementId {
  LabelText = 'labelText',
  ProgressBar = 'progressBar',
  ProgressStatusText = 'progressStatusText',
}
